/**
 * Responsável por desenhar os markers na tela de detalhe da rota
 * Created by adalto on 5/8/14.
 */

Greenmile.RouteDetail = Greenmile.RouteDetail || {};

Greenmile.RouteDetail.EventRoute = function (map, routeId) {

    this.requestEventsAndAddOnMap = () => {
      const screenListEvent = Monet.Session.RouteDetail.screensList[routeId];
      const beginDate = document.querySelector(`${screenListEvent.tabSelector} input[name='routePlay_initialDate']`);
      const endDate = document.querySelector(`${screenListEvent.tabSelector} input[name='routePlay_finalDate']`);
      const eventForm = App.Forms[`RouteDetails_${routeId}`];
      const { eventsRoute } = eventForm;

      const callbackAddEvents = () => {
        const { map, events, mapRouteDetail, router: { eventId } } = screenListEvent;
        const callback = () => {
          if (eventId) {
            setTimeout(function () {
              mapRouteDetail.focusOnTheEvent(eventId);
            }, 600);
          }
        };
        if (eventId) {
          map.eventId = eventId;
        }
        eventsRoute.cleanMarkerEvent(map);
        eventsRoute.addEventsOnMap(map, events, `RouteDetails_${routeId}`, callback);
      };

      const valueBegin = beginDate ? Monet.Format.DateTime.parseLocaleToISOString(beginDate.value) : '';
      const valueEnd = endDate ? Monet.Format.DateTime.parseLocaleToISOString(endDate.value) : '';
      const params = {
          callback: callbackAddEvents,
          beginData: valueBegin,
          endDate: valueEnd,
          eventId:  screenListEvent.router.eventId
      };

      eventsRoute.requestEvent(params);
    };

    this.cleanMarkerEvent = (callback) => {
      const eventForm = App.Forms[`RouteDetails_${routeId}`];
      const { eventsRoute } = eventForm;
      eventsRoute.cleanMarkerEvent(map);
      if (callback) {
        callback();
      }
    };

};
